import { Directive, effect, input, signal } from '@angular/core'

import { TemplateConfigInterfaceFromCollection } from '@flowx/core-sdk'
import { ThemeComponent } from '@flowx/core-theme'
import { applyLayoutStyles } from '@flowx/core-theme'

@Directive({
  selector: '[flxLayoutStyle]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxLayoutStyleDirective {
  flxLayoutStyle = input.required<{
    style: TemplateConfigInterfaceFromCollection['displayOptions']['style']
    componentType?: ThemeComponent
    className?: string
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(() => {
      const className = applyLayoutStyles(
        this.flxLayoutStyle().style,
        this.flxLayoutStyle().className
      )
      this.styleClassName.set(className)
    })
  }
}
